import { Radio as BaseRadio } from '@change-corgi/design-system-legacy/components/forms';

import type { Props as SelectionProps } from '../../components/Selection';

type Props = {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'data-qa': SelectionProps['qaSelectorSelection'];
	checked: SelectionProps['checked'];
};

export function Radio({ 'data-qa': dataQa, checked }: Props): JSX.Element {
	return (
		<BaseRadio
			data-qa={dataQa}
			data-testid="selection-radio"
			checked={checked}
			readOnly
			label=""
			sx={{
				accentColor: 'sunrise.semantic.fill.accent.primary.strong',
				height: '18px',
				marginTop: '4px',
				width: '18px',
			}}
		/>
	);
}
